import { SlideConfig } from '../types';

export const SLIDE_TO_BENEFIT_KEY: Record<string, string> = {};

export const SLIDES_CONFIG: SlideConfig[] = [
  {
    id: 'casa',
    type: 'INFO',
    title: 'Quanto vale la tua vecchia caldaia?',
  },
  {
    id: 'impianto',
    type: 'INFO',
    title: 'Ancora tre cose',
  },
  {
    id: 'contatti',
    type: 'INFO',
    title: 'A chi intestiamo la valutazione?',
  },
  {
    id: 'loading',
    type: 'INFO',
    title: 'Invio della richiesta in corso...',
  },
  {
    id: 'success',
    type: 'INFO',
    title: 'Le tue preferenze',
  },
  {
    id: 'error',
    type: 'INFO',
    title: 'Qualcosa è andato storto',
  },
];

export const PROGRESS_SLIDE_IDS = SLIDES_CONFIG
  .filter((slide) => slide.type === 'SINGLE_ANSWER' || slide.type === 'FORM_INPUT')
  .map((slide) => slide.id);

export function getBenefitKeyForSlide(slideId: string): string {
  return SLIDE_TO_BENEFIT_KEY[slideId] || slideId;
}

export function getBenefitShortName(benefitText: string | null): string {
  if (!benefitText) return 'il prossimo Beneficio';
  return benefitText;
}
